"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Symbol = require("es6-symbol");
var TYPES = {
    IBaasicAppOptions: Symbol("IBaasicAppOptions"),
    IAppOptions: Symbol("IAppOptions"),
    IStorageHandler: Symbol("IStorageHandler"),
    IEventHandler: Symbol("IEventHandler"),
    ITokenHandler: Symbol("ITokenHandler"),
    IUserHandler: Symbol("IUserHandler"),
    IBaasicApp: Symbol("IBaasicApp"),
    IBaasicPlatform: Symbol("IBaasicPlatform"),
    IDefaultStorageConfig: Symbol("IDefaultStorageConfig")
};
exports.TYPES = TYPES;
